module.exports = __webpack_public_path__ + "img/42-green.0f883a35.svg";